import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Menu } from "antd";
import { Link } from "react-router-dom";
import IntlMessages from "../../util/IntlMessages";
import { CleanNavBarItems, SetNavBarItems } from '../../appRedux/actions/Setting'
import {
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL
} from "../../constants/ThemeSetting";


const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;

const HorizontalNav = () => {


  const { companyConsolidatedId, id: CompanyId, allowUnify: IsUnify } = useSelector(({ auth }) => ({ ...auth.company, allowUnify: auth.companyGroup.allowUnify }));
  const navStyle = useSelector(({ settings }) => settings.navStyle);
  //const pathname = useSelector(({ settings }) => settings.pathname);
  const pathname = useSelector(({ common }) => common.pathname);
  const navBarItems = useSelector(({ settings }) => settings.NavBarItems);
  const { user } = useSelector(({ auth }) => auth);
  const dispatch = useDispatch();

  const getNavStyleSubMenuClass = (navStyle) => {
    switch (navStyle) {
      case NAV_STYLE_DEFAULT_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve";
      case NAV_STYLE_INSIDE_HEADER_HORIZONTAL:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-inside-submenu-popup-curve";
      case NAV_STYLE_BELOW_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-below-submenu-popup-curve";
      case NAV_STYLE_ABOVE_HEADER:
        return "gx-menu-horizontal gx-submenu-popup-curve gx-above-submenu-popup-curve";
      default:
        return "gx-menu-horizontal";

    }
  };

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split('/')[1];

  useEffect(() => {
    if (user.UserRolePOS === 2 || typeof (user.UserRolePOS) === 'undefined') {
      dispatch(SetNavBarItems());
    }
    return () => {
      dispatch(CleanNavBarItems());
    }
  }, [])

  return (
    <Menu
      defaultOpenKeys={[defaultOpenKeys]}
      selectedKeys={[selectedKeys]}
      mode="horizontal"
      subMenuOpenDelay={0}
      subMenuCloseDelay={0.1}
    >
      {
        navBarItems == null ? null :
          navBarItems.map((item, Mi) => {
            return (
              <SubMenu key={`Module${item.moduleId}`} className={getNavStyleSubMenuClass(navStyle)}
                title={item.moduleDisplay}>
                {
                  item.imrTabsInterfaces.map((tab) => {

                    return (
                      <Menu.ItemGroup key={`Module${item.moduleId}Tab${tab.tabId}ItemGroup`}>
                        <Menu.Divider />
                        <Menu.Item key={`Module${item.moduleId}Tab${tab.tabId}Interface0`}>
                          <Link to="#"><b> <i className="icon icon-widgets" />
                            {tab.tabsDisplay}</b>
                          </Link>
                        </Menu.Item>
                        <Menu.Divider />
                        {
                          tab.moduleInterfaces.map((interfa) => {
                            // Skip if it's a child
                            if (interfa.idInterfaceParent != null) return null;

                            const children = tab.moduleInterfaces.filter(
                              (x) => x.idInterfaceParent === interfa.id
                            );

                            // If has children -> render SubMenu
                            if (children.length > 0) {
                              return (
                                <SubMenu
                                  key={interfa.id}
                                  title={interfa.displayInterface}
                                  style={{ paddingLeft: 30, height: 30 }}
                                >
                                  {children.map((child) => (
                                    <Menu.Item
                                      key={child.url ? child.url.replace("/", "") : `child-${child.id}`}
                                      //disabled={!child.hasAccess}
                                      style={{ height: 30 }}
                                    >
                                      <Link
                                        to={`${child.url}?I=${child.id}&T=${tab.tabId}&M=${item.moduleId}`}
                                      >
                                        {child.displayInterface}
                                      </Link>
                                    </Menu.Item>
                                  ))}
                                </SubMenu>
                              );
                            }

                            // Otherwise -> render single Menu.Item
                            return (
                              <Menu.Item
                                key={interfa.url ? interfa.url.replace("/", "") : `item-${interfa.id}`}
                                //disabled={!interfa.hasAccess}
                                style={{ height: 30 }}
                              >
                                <Link
                                  to={`${interfa.url}?I=${interfa.id}&T=${tab.tabId}&M=${item.moduleId}`}
                                  style={{ paddingLeft: 30 }}
                                >
                                  {interfa.displayInterface}
                                </Link>
                              </Menu.Item>
                            );
                          })
                        }
                      </Menu.ItemGroup>
                    )
                  })
                }
              </SubMenu>
            )
          })
      }

    </Menu>

  );
};

HorizontalNav.propTypes = {};

export default HorizontalNav;

